import { createApp, type App } from 'vue';
import PaymentSuccessDialog from './src/PaymentSuccessDialog.vue';
import { getCurrentLanguage } from '@eureka/language-tool';
import { createI18n } from 'vue-i18n';
import { cn, en, jp, tw } from './src/locales';

const i18n = createI18n({
    legacy: false,
    locale: getCurrentLanguage(),
    fallbackLocale: 'en',
    messages: {
        cn,
        en,
        jp,
        tw,
    },
});

interface PaymentSuccessDialogOptions {
    email: string;
}

export function openPaymentSuccessDialog(options: PaymentSuccessDialogOptions) {
    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    document.body.appendChild(div);

    const unmountApp = (app: App) => {
        app.unmount();
        document.body.removeChild(div);
    };

    const promise = new Promise<boolean | undefined>((resolve) => {
        const app = createApp(PaymentSuccessDialog, {
            email: options.email,
            callback: () => {
                resolve(true);
                unmountApp(app);
            },
        });
        app.use(i18n);
        app.mount(div);
    });

    return promise;
}
